import React from 'react';
import "../less";
import green_card_order_img from "../img/green_card_order_img.png";
import bolt_card_order_img from "../img/bolt_card_order_img.png";
import prostor_card_order_img from '../img/prostor_card_order_img.webp';
import vygoda_card_order_img from "../img/vygoda_card_order_img.png";
import yellow_card_order_img from "../img/yellow_card_order_img.png";
import diia_card_order_img from "../img/diia_card_order_img.png";
import repair_card_order_img from "../img/repair_card_order_img.png";
import atb_card_order_img from "../img/atb_card_order_img.png";
import cashback_ua_card_order_img from "../img/cashback_ua_card_order_img.png";
import premium_card_order_img from "../img/premium_card_order_img.png";
import kid_card_order_img from "../img/kid_card_order_img.png";
import ukrainians_together_card_order_img from "../img/ukrainians_together_card_order_img.png";
import fop_order_img from "../img/fop_order_img.png";
import download_app_bottom_img from '../img/download_app_bottom_img.png';
import green_card_qr from "../img/green_card_qr.svg";
import bolt_card_qr from "../img/bolt_card_qr.svg";
import prostor_card_qr from "../img/prostor_card_qr.svg";
import vygoda_card_qr from "../img/vygoda_card_qr.svg";
import yellow_card_qr from "../img/yellow_card_qr.svg";
import diia_card_qr from "../img/diia_card_qr.svg";
import repair_card_qr from "../img/repair_card_qr.svg";
import atb_card_qr from "../img/atb_card_qr.svg";
import cashback_card_qr from "../img/cashback_card_qr.svg";
import premium_card_qr from "../img/premium_card_qr.svg";
import kid_card_qr from "../img/kid_card_qr.svg";
import ukrainians_together_card_qr from "../img/ukrainians_together_card_qr.svg";
import cards_list_qr from "../img/cards_list_qr.svg";
import fop_qr from "../img/fop_qr.svg";
import bright_start_promo_qr from "../img/bright_start_promo_qr.svg";
import download_app_bottom_qr from '../img/download_app_bottom_qr.svg';
import pos_qr from '../img/pos_qr.svg';
import success_img from "../img/success_img.png";
import error_img from "../img/error_img.png";
import google_play_icon from "../img/google_play_icon.svg";
import app_store_icon from "../img/app_store_icon.svg";
import app_gallery_icon from "../img/app_gallery_icon.svg";
import checkbox_icon from "../img/checkbox_icon.svg";
import { IMaskInput } from 'react-imask';
import close_icon from '../img/close_icon.svg';
import { appGalleryLink, appStoreLink, googlePlayLink } from '../../../services/urls/urls';
import { ReactSVG } from 'react-svg';
import Modal from "../../../pages/Services/components/Abank24/components/Modal/templates/interactive";
import formTexts from '../enums/form_texts.json';
import linksForDownloadData from '../enums/links_for_download.json';

const downloadHrefMap = {
  googlePlayLink,
  appStoreLink,
  appGalleryLink
};

const downloadImagesMap = {
  google_play_icon,
  app_store_icon,
  app_gallery_icon
};

export default function template() {
  const { cardList, isOpen, isBusiness, downloadAppBottom, forceMode, qrOverride } = this.props;
  const { contactPhoneNumber, isMobile, activeScreen, withUtmMarks, isLoading, productName, ageConfirm } = this.state;

  const isUtmMode  = forceMode === "utm" ? true : forceMode === "no-utm" ? false : withUtmMarks;

  const isMobileWithUtmMarks = isUtmMode && isMobile;
  const isMobileWithoutUtmMarks = !isUtmMode && isMobile;

  const imageObject = {
    green: green_card_order_img,
    bolt: bolt_card_order_img,
    prostor: prostor_card_order_img,
    vygoda: vygoda_card_order_img,
    yellow: yellow_card_order_img,
    diia: diia_card_order_img,
    eVidnovlennia: repair_card_order_img,
    atb: atb_card_order_img,
    cashback_ua: cashback_ua_card_order_img,
    platinum: premium_card_order_img,
    kid: kid_card_order_img,
    ukrainians_together: ukrainians_together_card_order_img,
    fop: fop_order_img,
    bright_start_promo: green_card_order_img
  };

  const qrCodes = {
    green: green_card_qr,
    bolt: bolt_card_qr,
    prostor: prostor_card_qr,
    vygoda: vygoda_card_qr,
    yellow: yellow_card_qr,
    diia: diia_card_qr,
    eVidnovlennia: repair_card_qr,
    atb: atb_card_qr,
    cashback_ua: cashback_card_qr,
    platinum: premium_card_qr,
    kid: kid_card_qr,
    ukrainians_together: ukrainians_together_card_qr,
    fop: fop_qr,
    bright_start_promo: bright_start_promo_qr,
    POS: pos_qr
  };

  const linksForDownload = linksForDownloadData.map(item => ({
    ...item,
    href: downloadHrefMap[item.href],
    img: downloadImagesMap[item.img]
  }));

  const finalTexts = {
    error: {
      img: error_img,
      title: "CARD_ORDER_MODAL_ERROR_TITLE",
      subtitle: "CARD_ORDER_MODAL_ERROR_SUBTITLE",
      btnText: "CARD_ORDER_MODAL_ERROR_BTN_TEXT",
    },
    success: {
      img: success_img,
      title: "CARD_ORDER_MODAL_SUCCESS_TITLE",
      subtitle: "CARD_ORDER_MODAL_SUCCESS_SUBTITLE",
      btnText: "CARD_ORDER_MODAL_SUCCESS_BTN_TEXT",
    },
    successKid: {
      img: success_img,
      title: "CARD_ORDER_MODAL_SUCCESS_TITLE",
      subtitle: "CARD_ORDER_MODAL_SUCCESS_KID_SUBTITLE",
      btnText: "CARD_ORDER_MODAL_SUCCESS_BTN_TEXT",
    }
  };

  let currentFinalTexts = null;

  if (activeScreen !== 'form') {
    currentFinalTexts =
      activeScreen === "success" && productName === "kid"
        ? finalTexts.successKid
        : finalTexts[activeScreen] || finalTexts.error;
  }

  const currentFormTexts =
    productName === 'POS'
      ? formTexts.pos
      : isBusiness
        ? formTexts.business
        : formTexts.default;

  if (isBusiness && isMobileWithoutUtmMarks) {
    return null;
  }

  return (
    <>
      {(!isMobile && !isUtmMode) ? (
        <Modal
          title={
            productName === 'POS'
                ? this.l10n('CARD_ORDER_MODAL_BUSINESS_QR_TEXT_POS')
                : isBusiness
                    ? this.l10n('CARD_ORDER_MODAL_BUSINESS_QR_TEXT')
                    : this.l10n('ABANK_24_MODAL_TEXT')
          }
          isOpen={isOpen}
          onClose={this.closeModal}
          qrCodeSrc={
            qrOverride
                ? qrOverride
                : cardList
                    ? cards_list_qr
                    : downloadAppBottom
                        ? download_app_bottom_qr
                        : qrCodes[productName]
          }
        />
      ) : (
        <div className={`card-order-modal ${activeScreen}-screen`} onClick={this.closeModal} onKeyDown={(e) => e.key === 'Enter' && this.closeModal()} tabIndex="0">
            <div
              className={`card-order-modal__body ${activeScreen === 'form' && productName === 'POS' ? 'card-order-modal__body_no-image' : ''}`}
              onClick={(e) => e.stopPropagation()}
              onKeyDown={(e) => e.key === 'Enter' && this.closeModal()}
              tabIndex="0"
            >
            <ReactSVG src={close_icon} className="card-order-modal__close" onClick={this.closeModal}/>
            {activeScreen === "form" ? (
              <>
                {productName !== 'POS' && (
                  <div className="card-order-modal__image">
                    <img
                      alt={`${productName} card image`}
                      src={
                        imageObject[productName]
                          ? imageObject[productName]
                          : downloadAppBottom
                            ? download_app_bottom_img
                            : green_card_order_img
                      }
                    />
                  </div>
                )}
                <div className="card-order-modal__left">
                  <h2 className="card-order-modal__title">
                    {isMobileWithoutUtmMarks 
                      ? this.l10n(currentFormTexts.title.mobile) 
                      : this.l10n(currentFormTexts.title.desktop)
                    }
                  </h2>
                  <div className="card-order-modal__subtitle">
                    {isMobileWithoutUtmMarks 
                      ? this.l10n(currentFormTexts.subtitle.mobile) 
                      : this.l10n(currentFormTexts.subtitle.desktop)
                    }
                  </div>
                  {(!isMobile || isMobileWithUtmMarks) && (
                    <>
                      <div className={`card-order-modal__input ${!contactPhoneNumber.isValid && !contactPhoneNumber.firstInput
                          ? 'card-order-modal__input_error'
                          : ''
                        }`}
                      >
                        <IMaskInput
                          mask={contactPhoneNumber.value || contactPhoneNumber.isTouched ? "+38 (\\000) 000 00 00" : false}
                          lazy={false}
                          definitions={{"0": /[0-9]/}}
                          unmask={false}
                          placeholder={contactPhoneNumber.value || contactPhoneNumber.isTouched ? undefined : this.l10n('CARD_ORDER_MODAL_FORM_PLACEHOLDER')}
                          placeholderChar=" "
                          value={contactPhoneNumber.value || ""}
                          onAccept={(value) => this.handleChange(value)}
                          onFocus={this.handleSetIsTouched}
                          onBlur={this.onBlurHandle}
                        />
                        <div className="card-order-modal__error">{this.l10n('CARD_ORDER_MODAL_FORM_ERROR')}</div>
                      </div>
                      {productName === "kid" && (
                        <div className="card-order-modal__checkbox-block" onClick={this.handleCheckbox} onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            e.stopPropagation();
                            this.handleCheckbox();
                          }
                        }}
                             tabIndex="0">
                          <div className={`card-order-modal__checkbox${ageConfirm ? ' card-order-modal__checkbox_checked' : ''}`}>
                            <ReactSVG src={checkbox_icon}/>
                          </div>
                          <div className="card-order-modal__checkbox-text">{this.l10n('CARD_ORDER_MODAL_FORM_CHECKBOX_TEXT')}</div>
                        </div>
                      )}
                      <button
                        onClick={this.sendForm}
                        disabled={!contactPhoneNumber.isValid || isLoading}
                        className={`card-order-modal__button 
                          ${!contactPhoneNumber.isValid
                          ? 'card-order-modal__button_disabled'
                          : ''
                        }`}
                        id={`${productName ? productName : ''} card-order-modal-button`}
                      >
                        {this.l10n('CARD_ORDER_MODAL_FORM_GET_LINK')}
                      </button>
                    </>
                  )}
                  {isMobileWithoutUtmMarks && (
                    <div className="card-order-modal__download download">
                      {linksForDownload.map((item, index) => (
                        <a key={index} href={item.href} target="_blank" className="download__item">
                          <ReactSVG src={item.img} className={`download__image download__image_${index + 1}`}/>
                          <span className="download__text">{this.l10n(item.text)}</span>
                        </a>
                      ))}
                    </div>
                  )}
                  {isMobile && <button className="card-order-modal__back-btn" onClick={this.closeModal}>{this.l10n('CARD_ORDER_MODAL_FORM_BACK')}</button>}
                </div>
              </>
            ) : (
              <>
                <div className="card-order-modal__image">
                  <img alt={`${activeScreen} image`} src={currentFinalTexts.img} />
                </div>
                <div className="card-order-modal__left">
                  <h2 className="card-order-modal__title">{this.l10n(currentFinalTexts.title)}</h2>
                  <div className="card-order-modal__subtitle">{this.l10n(currentFinalTexts.subtitle)}</div>
                  <button className="card-order-modal__btn" onClick={this.closeModal}>{this.l10n(currentFinalTexts.btnText)}</button>
                  {isMobile && <button className="card-order-modal__back-btn" onClick={this.closeModal}>{this.l10n('CARD_ORDER_MODAL_FORM_BACK')}</button>}
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </>
  )
}

